import Vue from 'vue'
import Axios from 'axios'
import ui from './ui'
import { store } from '../plugins/store'

const axios = {
  Get: function (controller, id) {
    store.commit('addRequest')
    if (id) {
      return Axios.get(
        process.env.VUE_APP_ROOT_API + controller + '/' + id
      ).then(HandleResponseBase, HandleErrorBase)
    } else {
      return Axios.get(
        process.env.VUE_APP_ROOT_API + controller
      ).then(HandleResponseBase, HandleErrorBase)
    }
  },
  GetAll: function (controller, dto) {
    store.commit('addRequest')
    return Axios.get(process.env.VUE_APP_ROOT_API + controller, {
      params: {
        request: dto || {}
      }
    }).then(HandleResponseBase, HandleErrorBase)
  },
  GetBlob: function (controller, dto) {
    store.commit('addRequest')
    return Axios.get(process.env.VUE_APP_ROOT_API + controller, {
      params: { request: dto || {} },
      responseType: 'blob' // Force to receive data in a Blob Format
    }).then(HandleBlobResponseBase, p => HandleBlobErrorBase(p).then())
  },
  PostBlob: function (controller, dto) {
    store.commit('addRequest')
    return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, { responseType: 'blob' }).then(
      HandleBlobResponseBase, p => HandleBlobErrorBase(p).then())
  },
  Post: function (controller, dto, headers) {
    store.commit('addRequest')
    if (headers) {
      return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, headers).then(
        HandleResponseBase,
        HandleErrorBase
      )
    } else {
      return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto).then(
        HandleResponseBase,
        HandleErrorBase
      )
    }
  },
  PostForm: function (controller, dto) {
    store.commit('addRequest')
    return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, { headers: { 'Content-Type': `multipart/form-data; boundary=${dto._boundary}` } }).then(
      HandleResponseBase,
      HandleErrorBase
    )
  },
  Put: function (controller, id, dto) {
    store.commit('addRequest')
    if (!dto) {
      dto = {}
    }
    return Axios.put(
      process.env.VUE_APP_ROOT_API + controller + '/' + id,
      dto
    ).then(HandleResponseBase, HandleErrorBase)
  },
  Persist: function (controller, dto, key) {
    if (!dto) { dto = {} }

    if (!key) { key = 'codigo' }

    if (dto[key]) { return util.Axios.Put(controller, dto[key], dto) } else { return util.Axios.Post(controller, dto) }
  },
  Delete: function (controller, id) {
    store.commit('addRequest')
    return Axios.delete(process.env.VUE_APP_ROOT_API + controller + '/' + (id || ''))
      .then(HandleResponseBase, HandleErrorBase)
  },
  DeleteAll: function (controller, dto) {
    store.commit('addRequest')
    return Axios.delete(process.env.VUE_APP_ROOT_API + controller, { params: dto })
      .then(HandleResponseBase, HandleErrorBase)
  },
  Dynamic: function (action, ...args) {
    store.commit('addRequest')
    return Axios[action](...args).then(
      HandleResponseBase,
      HandleErrorBase
    )
  },
  GetParams: function (controller, paramns) {
    store.commit('addRequest')
    if (!paramns) { paramns = {} }
    return Axios.get(process.env.VUE_APP_ROOT_API + controller, { params: paramns })
      .then(HandleResponseBase, HandleErrorBase)
  }
}

const util = {
  Axios: axios,
  // Função para substituir antigo SetAllButNull, sem precisar passar o contexto
  SetAllButNull: function (object, propName, sender) {
    sender = Object.assign(object[propName], getAllButNull(sender))
    Vue.set(object, propName, sender)
    object[propName] = Object.assign({}, object[propName])
  },
  Functions: {
    CopyObject: function (sender) {
      return JSON.parse(JSON.stringify(sender))
    },
    SetAllButNull: function (th, object, propName, sender) {
      sender = Object.assign(object[propName], getAllButNull(sender))
      th.$set(object, propName, sender)
      object[propName] = Object.assign({}, object[propName])
    },
    FileToString: function (file, callback) {
      if (!file || !file.name) { return false }
      const reader = new FileReader()
      reader.onload = function () {
        callback(reader.result)
      }
      reader.readAsText(file)
    },
    FileToByteArray: function (file, callback) {
      if (!file || !file.name) { return false }
      const reader = new FileReader()
      const fileByteArray = []
      reader.onloadend = function (evt) {
        if (evt.target.readyState === FileReader.DONE) {
          var arrayBuffer = evt.target.result
          var array = new Uint8Array(arrayBuffer)
          for (var i = 0; i < array.length; i++) {
            fileByteArray.push(array[i])
          }
          callback(fileByteArray)
        }
      }
      reader.readAsArrayBuffer(file)
    },
    ValidaDocumento: function (documento) {
      return util.Axios.Get('Util/ValidaDocumento', documento)
    },
    RemoveAcentos: function (texto) {
      return util.Axios.Get('Util/RemoveAcentos', texto)
    },
    GetThemeAttributes: function () {
      return util.Axios.Get('Util/GetThemeAttributes')
    }
  },
  Array: {
    OrderBy (data, column, desc) {
      const sort = data.sort(function (a, b) {
        return a[column] - b[column]
      })

      if (desc === 'desc') { return sort.reverse() } else { return sort }
    },
    GetValue (data, field, value) {
      if (!value && value !== 0) { return {} } else {
        const obj = data.find(p => p[field] && p[field].toString() === value.toString())
        if (obj) return obj
        else return {}
      }
    }
  },
  GetCrud: function (controller, methods) {
    var factory = {}
    if (!methods || (methods && methods.indexOf('get') >= 0)) {
      factory.Get = function (id) {
        return util.Axios.Get(controller, id)
      }
    }

    if (!methods || (methods && methods.indexOf('getall') >= 0)) {
      factory.GetAll = function (dto) {
        return util.Axios.GetAll(controller, dto)
      }
    }

    if (!methods || (methods && methods.indexOf('post') >= 0)) {
      factory.Post = function (dto) {
        return util.Axios.Post(controller, dto)
      }
    }

    if (!methods || (methods && methods.indexOf('put') >= 0)) {
      factory.Put = function (id, dto) {
        return util.Axios.Put(controller, id, dto)
      }
    }

    if (!methods || (methods && methods.indexOf('persist') >= 0)) {
      factory.Persist = function (dto, key) {
        return util.Axios.Persist(controller, dto, key)
      }
    }

    if (!methods || (methods && methods.indexOf('delete') >= 0)) {
      factory.Delete = function (id) {
        return util.Axios.Delete(controller, id)
      }
    }
    // utilizado na montagem da api index.js
    factory.controller = controller

    return factory
  },
  Auth: {
    RegisterToken: function (data, userName, extendUser) {
      if (ui.PostLoadData(data)) {
        if (data.accessToken) {
          if (!extendUser) { extendUser = {} }
          const user = {
            ...extendUser,
            email: data.email,
            token: data.accessToken,
            refreshToken: data.refreshToken,
            roles: data.roles && data.roles.length > 0 ? data.roles : util.Auth.GetUserRole(data.accessToken),
            expiresAt: new Date(
              new Date().getTime() + data.expires * 1000
            ),
            identificador: userName || data.nomeUsuario || data.identificador
          }
          return user
        } else return false
      } else { return false }
    },
    Logout: function (showMessage) {
      if (showMessage === true) {
        ui.ShowError(
          'Erro',
          'Sessão expirada ou acesso não autorizado '
        )
        store.dispatch('logout')
      } else if (showMessage === 'confirma') {
        ui.Mensagem('erro', 'Sessão expirada ou acesso não autorizado ', function () {
          store.dispatch('logout')
        })
      } else { store.dispatch('logout') }
      return false
    },
    GetUserRole (token) {
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload).role
      } catch {
        const jwtData = token.split('.')[1]
        const decodedJwtJsonData = window.atob(jwtData)
        return JSON.parse(decodedJwtJsonData).role
      }
    }
  }
}

function getAllButNull (sender) {
  let aux = {}
  if (typeof sender === 'object') {
    Object.keys(sender).forEach(p => {
      if (sender[p] !== null && sender[p] !== undefined) {
        if (typeof sender[p] === 'object' && !Array.isArray(sender[p])) { sender[p] = getAllButNull(sender[p]) }
        aux[p] = sender[p]
      }
    })
  } else if (sender) { aux = sender }
  return aux
}

function HandleResponseBase (response) {
  store.commit('removeRequest')

  if ((response.count && response.data) || (response.count === 0 && response.data === [])) { return response; }
  if (response.data.meta) { return response.data; }
  if (response.data.data || response.data.data === []) {
    if (response.data.count || response.data.count === 0) { return response.data }
    return response.data.data;
  }

  return response.data;
}

function HandleBlobResponseBase (response) {
  store.commit('removeRequest')

  return response;
}

function HandleErrorBase (error) {
  store.commit('removeRequest')
  if (error) {
    const response = error.response
    if (response) {
      if (response.data.errors) {
        let errorMessage = '';

        if (response.data.errors.length > 1) {
          // Ainda não existem casos que cairão aqui
          const errors = []
          response.data.errors.map(x => {
            errors.push(x.detail)
          })
          errorMessage = errors.join(', ')
          return { success: false, mensagem: errorMessage }
        }

        errorMessage = response.data.errors[0];
        return { success: false, mensagem: errorMessage.detail }
      }

      if (response.data.message) {
        return { success: false, mensagem: response.data.message }
      }

      if (typeof response.data === 'string' && response.status && response.statusText) {
        return {
          success: false, codErro: response.status, mensagem: response.data || (response.status + ' - ' + response.statusText)
        }
      }

      if (response.data) {
        if (response.data.status && response.data.title) {
          return {
            success: false, codErro: response.data.status, mensagem: response.data.status + ' - ' + response.data.title
          }
        }
        if (response.data.error) {
          return {
            success: false, codErro: response.status, mensagem: response.data.error
          }
        }
      }

      if (response.status) {
        if (!response.status.statusText && (typeof response.data === 'string' && !!response.data)) {
          return {
            sucess: false, coderro: response.status, mensagem: response.data
          }
        } else {
          return {
            success: false, codErro: response.status, mensagem: response.status + ' - ' + response.statusText
          }
        }
      }

      return response
    }
    return error
  }
  return { error: 'Erro' }
}

function HandleBlobErrorBase (error) {
  return new Promise((resolve) => {
    store.commit('removeRequest')
    if (error && error.response) {
      var fr = new FileReader();

      fr.onload = function () {
        const response = JSON.parse(this.result)
        resolve({
          success: false, codErro: error.response.status, mensagem: error.response.status + ' - ' + response.Message
        })
      }

      fr.readAsText(error.response.data);
    } else { HandleErrorBase(error) }
  })
}

export default util
